const appData = {
  "appDomain": "http://0.0.0.0:3000",
  "appUrl": "http://0.0.0.0:3000",
  "publicUrl": "http://0.0.0.0:3000",
  "publicRoutePath": "http://0.0.0.0:3000",
  "gseoClient": "gseo-offer-ppc",
  "gseoRecaptcha": "6LfSxMMaAAAAAGziyyYOEc7MosJoqW8j0nj2j0dP",
  "analyticsUA": "UA-105310868-2",
  "ga4_id": "G-NEFBC77K8L",
  "tag_manager_id": "GTM-K9F23L",
  "meta_pixel_id": "466341968455484"
};
export {appData};
